/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/static-property-placement */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable no-else-return */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

/* STYLES */
import './UserProfileV2.scss';

/* CONTEXTS */
import { PageContext } from '../../../contexts/ContextCreator';

/* COMPONENTS */
import Layout from '../../../components/Layout/Layout';
import LeftRailLayout from '../../../components/LeftRailLayout/LeftRailLayout';
import ProfileIdentityCard from '../../../components/Users/ProfileIdentityCard/ProfileIdentityCard';
import CommonCardShell from '../../../components/Layout/CommonCardShell/CommonCardShell';
import UserExperienceEducationCallToAction from '../../../components/Users/UserExperienceEducationCallToAction/UserExperienceEducationCallToAction';
import EduExpListContainer from '../../../components/Users/UserProfile/EduExpListContainer/EduExpListContainer';
import { intToMonth } from '../../../utilities/ui_utilities';
import UserInterests from '../../../components/Users/UserProfile/UserInterests/UserInterests';
import DemographicsCard from '../../../components/CallToAction/DemographicsCard/DemographicsCard';
import DreamCompaniesCard from '../../../components/Users/DreamCompaniesCard/DreamCompaniesCard';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

/* HELPERS */
import { updateProfile } from '../../../components/Includes/Constants/user';
import ResponsivePicture from '../../../components/Elements/ResponsivePicture/ResponsivePicture';
import { PAGE_DISPLAY_MODE } from '../../constants';
import { profileEnrichmentFlowType } from '../../../components/Modals/Flows/ProfileEnrichment/ProfileEnrichment';
import {
    buildEnrichmentFormState,
    tagAndCombineEnrichments,
} from '../../../components/Modals/Flows/ProfileEnrichment/constants';

export default class UserProfileV2 extends React.PureComponent {
    constructor(props) {
        super(props);

        const { educations, experiences } = this.props;

        this.state = {
            currentExperiences: experiences || [],
            currentEducations: educations || [],
            hasMinimalProfile: educations.length + experiences.length > 0,
        };
    }

    static propTypes = {
        name: PropTypes.string,
        logo: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
        credential: PropTypes.string,
        aboutMe: PropTypes.string,
        website: PropTypes.string,
        isPublic: PropTypes.bool,
        profileUserId: PropTypes.number,
        relationsToUser: PropTypes.shape({
            connectionStatus: PropTypes.string,
            isFollowing: PropTypes.bool,
        }),
        interests: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
            })
        ),
        communityTopics: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                label: PropTypes.string,
                url: PropTypes.string,
                isActive: PropTypes.number,
            })
        ),
        experiences: PropTypes.arrayOf(PropTypes.object),
        educations: PropTypes.arrayOf(PropTypes.object),
        demographics: PropTypes.shape({
            /**
             * options for multiselecting ethnicity
             */
            ethnicityOptions: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number,
                    title: PropTypes.string,
                })
            ),
            /**
             * options for multiselecting ethnicity
             */
            orientationOptions: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number,
                    title: PropTypes.string,
                })
            ),
            gender: PropTypes.string,
            ethnicity: PropTypes.array,
            sexualOrientation: PropTypes.array,
            veteran: PropTypes.string,
            disability: PropTypes.string,
            otherComments: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number,
                    type: PropTypes.string,
                    comment: PropTypes.string,
                })
            ),
        }),
        hasPDLmatch: PropTypes.bool,
    };

    // todo - remove demographics
    static defaultProps = {
        communityTopics: [],
        interests: [],
        educations: [],
        experiences: [],
        demographics: {},
        hasPDLmatch: false,
    };

    static contextType = PageContext;

    componentDidMount = async () => {
        const { triggerFlowModal, jobProfileSnippet } = this.context;

        const { hasPDLmatch, isPublic } = this.props;

        if (!isPublic && hasPDLmatch && !jobProfileSnippet.isCompleted) {
            const { enrichments } = await this.fetchEnrichmentData();

            if (!enrichments) return;

            const mixedAndTaggedEnrichments = tagAndCombineEnrichments(
                enrichments
            );

            const initialFormState = buildEnrichmentFormState(
                mixedAndTaggedEnrichments
            );

            const closeOptions = { backgroundExits: false, escapeExits: true };

            const modalData = {
                stepPopulateProps: initialFormState,
                generalModalProps: {
                    closeOptions,
                    enrichments: mixedAndTaggedEnrichments,
                    setHistoryByType: this.setHistoryByType,
                    getCurrentExpEduData: this.getCurrentExpEduData,
                },
            };
            return triggerFlowModal(profileEnrichmentFlowType, modalData);
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        const { currentEducations, currentExperiences } = this.state;

        const historiesLength =
            currentEducations.length + currentExperiences.length;

        // user had edus/exps but has removed them all - toggle extra CTAs encouraging user to add edus/exps
        if (prevState.hasMinimalProfile && historiesLength === 0)
            return this.setState({ hasMinimalProfile: false });

        // user had 0 educations/experiences - now has at least 1
        if (!prevState.hasMinimalProfile && historiesLength > 0) {
            // toggle minimal profile
            return this.setState({ hasMinimalProfile: true });
        }
    };

    getCurrentExpEduData = () => {
        const { currentExperiences, currentEducations } = this.state;

        return { currentExperiences, currentEducations };
    };

    fetchEnrichmentData = async () => {
        const enrichmentEndpoint = '/api/user/enrichments';

        try {
            const response = await axios.get(enrichmentEndpoint);
            const { enrichments } = response.data;

            if (!enrichments) return { enrichments: null };

            return { enrichments };
        } catch (error) {
            console.error('enrichment fetch error: ', error);
            return { enrichments: null };
        }
    };

    handleSelfDeactivate = () => {
        const pageContext = this.context;

        const confirmationModalProps = {
            heading: 'Deactivate account',
            subheading: 'Are you sure you want to deactivate your account?',
            buttonMetas: [
                {
                    buttonText: 'Cancel',
                    buttonType: 'tertiary-blue-gray',
                },
                {
                    buttonText: 'Deactivate',
                    buttonType: 'secondary-blue-gray',
                    onClickHandler: async () => {
                        try {
                            await axios.post('/api/user/deactivate');

                            pageContext.modalTrigger('ConfirmationModal', {
                                heading: 'Account deactivated',
                                subheading:
                                    'Your account has been deactivated. You will be redirected to the homepage.',
                                buttonMetas: [
                                    {
                                        buttonText: 'OK',
                                        buttonType: 'purple-medium-white',
                                        onClickHandler: () => {
                                            window.location = '/';
                                        },
                                    },
                                ],
                                onClose: () => (window.location = '/'),
                            });
                        } catch (e) {
                            // show error modal
                            console.error(e);
                            pageContext.modalTrigger('ConfirmationModal', {
                                heading: 'Error',
                                subheading:
                                    'There was an error deactivating your account. Please try again later.',
                                buttonMetas: [
                                    {
                                        buttonText: 'OK',
                                        buttonType: 'purple-medium-white',
                                    },
                                ],
                                onClose: () => pageContext.modalTrigger(),
                            });
                        }
                    },
                },
            ],
            onClose: () => pageContext.modalTrigger(),
        };

        pageContext.modalTrigger('ConfirmationModal', confirmationModalProps);
    };

    setCurrentEducations = (educations) => {
        if (!educations) return;
        return this.setState({ currentEducations: educations });
    };

    setCurrentExperiences = (experiences) => {
        if (!experiences) return;
        return this.setState({ currentExperiences: experiences });
    };

    setHistoryByType = (type = 'education') => (newData) => {
        if (type === 'education') {
            return this.setCurrentEducations(newData);
        } else if (type === 'experience') {
            return this.setCurrentExperiences(newData);
        }
    };

    isEmptyPublicProfile = () => {
        const { isPublic, interests, communityTopics } = this.props;
        return (
            isPublic &&
            !interests.length &&
            !communityTopics.length &&
            !this.state.hasMinimalProfile
        );
    };

    /**
     * return location name with 5 digit zipcode removed
     * @param {String} locationName ex: "Fair Lawn, NJ 07410, USA"
     * @returns {String} ex: "Fair Lawn, NJ, USA"
     */
    getFormattedLocationName = (locationName) => {
        if (typeof locationName !== 'string') {
            return '';
        }

        return locationName.replace(/\s\d{5}/, '');
    };

    /**
     * returns an common formatted data shape for both educations or experiences type of list
     * @param {String} listType The type of the list passing in
     * @param {Array} list The list
     * @returns {Array}
     */
    serializePersonalHistory = (listType, list) => {
        if (!listType || !Array.isArray(list) || list.length === 0) {
            return [];
        }

        if (listType === 'experience') {
            return list.map((item) => {
                let time = '';
                if (item.startYear) {
                    const startMonth = intToMonth(item.startMonth);

                    time = item.isCurrent
                        ? `${startMonth} ${item.startYear} - Present`
                        : `${startMonth} ${item.startYear} - ${intToMonth(
                              item.endMonth
                          )} ${item.endYear}`;
                }

                return {
                    id: item.experienceId,
                    type: listType,
                    title: item.title,
                    organizationName: item.company.companyName,
                    location: item.isRemote
                        ? 'Remote'
                        : this.getFormattedLocationName(item.location.name),
                    time,
                    description: item.description,
                };
            });
        }

        if (listType === 'education') {
            return list.map((item) => {
                const formattedDegree = item.degree
                    .replace(' Degree', '')
                    .replace("'", '');
                const degreePostfix = item.field ? `, ${item.field}` : '';
                const programName = `${formattedDegree}${degreePostfix}`;
                let time = '';
                if (item.startYear) {
                    time = item.isCurrent
                        ? `${item.startYear} - Present`
                        : `${item.startYear} - ${item.endYear}`;
                }

                return {
                    id: item.educationId,
                    type: listType,
                    title: item.school.name,
                    organizationName: programName,
                    location: item.isRemote
                        ? 'Remote'
                        : this.getFormattedLocationName(item.location.name),
                    time,
                    description: item.description,
                };
            });
        }

        return [];
    };

    shouldDisplayProfileSection = (
        requiresMinimalProfile = true,
        sectionContent = []
    ) => {
        if (this.props.isPublic) {
            return sectionContent.length > 0;
        }

        if (requiresMinimalProfile) {
            return this.state.hasMinimalProfile || sectionContent.length > 0;
        }

        return true;
    };

    renderTopBanner = () => {
        const headerFooterImageBreakpoints = {
            desktop: { width: 1500 },
            tablet: { width: 992 },
            smallTablet: { width: 768 },
            mobile: { width: 575 },
        };

        return (
            <section>
                <div className="wrapper-div">
                    <ResponsivePicture
                        className="top-banner-image"
                        cloudinaryID="/v1/blue_bkgd_1500x180_pqvti3.png"
                        forceImageSize
                        breakpoints={headerFooterImageBreakpoints}
                    />
                </div>
            </section>
        );
    };

    render() {
        const {
            name,
            logo,
            credential,
            aboutMe,
            website,
            isPublic,
            profileUserId,
            relationsToUser,
            PAGE_PROPS,
            desiredCompanies,
            interests,
            username,
            isVip,
        } = this.props;
        const {
            currentEducations,
            currentExperiences,
            hasMinimalProfile,
        } = this.state;
        const { featureFlags } = PAGE_PROPS;

        const profileIdentityCardProps = {
            name,
            username,
            logo,
            credential,
            aboutMe,
            website,
            isPublic,
            profileUserId,
            relationsToUser,
            isVip,
        };
        const showAdditionalSections =
            this.context.pageDisplayMode === PAGE_DISPLAY_MODE.USER_DEFAULT;

        const mainContentClassName = this.isEmptyPublicProfile()
            ? 'main-content-hide'
            : '';

        return (
            <div className="page-User-UserProfileV2">
                <SnowplowPageViewTracker
                    pageSection={PAGE_VIEW_SECTIONS.USER_PORTAL}
                    pageType={PAGE_VIEW_TYPES.CONTENT}
                    pageEntityId={profileUserId}
                />
                <Layout PAGE_PROPS={PAGE_PROPS} hasChangingContainer={false}>
                    {this.renderTopBanner()}

                    <LeftRailLayout mobileLayoutClass="rail-content-on-top">
                        <LeftRailLayout.LeftRail>
                            <CommonCardShell>
                                <ProfileIdentityCard
                                    {...profileIdentityCardProps}
                                />
                            </CommonCardShell>

                            {featureFlags &&
                                featureFlags.demographicsFlow &&
                                showAdditionalSections &&
                                !isPublic && (
                                    <DemographicsCard
                                        {...this.props.demographics}
                                    />
                                )}
                        </LeftRailLayout.LeftRail>

                        <LeftRailLayout.MainContent
                            className={mainContentClassName}
                        >
                            {showAdditionalSections &&
                                !isPublic &&
                                !hasMinimalProfile && (
                                    <UserExperienceEducationCallToAction />
                                )}

                            {this.shouldDisplayProfileSection(
                                false,
                                currentExperiences
                            ) && (
                                <EduExpListContainer
                                    listType="experience"
                                    isPublic={isPublic}
                                    serializedPersonalHistoryList={this.serializePersonalHistory(
                                        'experience',
                                        currentExperiences
                                    )}
                                    rawPersonalHistoryList={currentExperiences}
                                    updateHistoryList={this.setHistoryByType(
                                        'experience'
                                    )}
                                />
                            )}

                            {this.shouldDisplayProfileSection(
                                false,
                                currentEducations
                            ) && (
                                <EduExpListContainer
                                    listType="education"
                                    isPublic={isPublic}
                                    serializedPersonalHistoryList={this.serializePersonalHistory(
                                        'education',
                                        currentEducations
                                    )}
                                    rawPersonalHistoryList={currentEducations}
                                    updateHistoryList={this.setHistoryByType(
                                        'education'
                                    )}
                                />
                            )}

                            {showAdditionalSections && (
                                <React.Fragment>
                                    {this.shouldDisplayProfileSection(
                                        true,
                                        interests
                                    ) && (
                                        <CommonCardShell>
                                            <UserInterests
                                                interests={this.props.interests}
                                                editMode={!isPublic}
                                                onSubmit={updateProfile}
                                            />
                                        </CommonCardShell>
                                    )}

                                    {!isPublic &&
                                        (this.state.hasMinimalProfile ||
                                            desiredCompanies.length > 0) && (
                                            <CommonCardShell>
                                                <DreamCompaniesCard
                                                    desiredCompanies={
                                                        desiredCompanies
                                                    }
                                                    isPublic={isPublic}
                                                />
                                            </CommonCardShell>
                                        )}
                                            {!isPublic && (
                                                <CommonCardShell>
                                                    <section className="component-Users-DeactivateCard">
                                                        <div className="deactivate-inline">
                                                            <span className="deactivate-disclaimer">
                                                                You will be unsubscribed from all our emails and communications. If you want to activate your account again, please contact our support team at info@fairygodboss.com
                                                            </span>
                                                            <button
                                                                className="deactivate-button purple-medium-white small"
                                                                data-qa-deactivate="deactivate-account"
                                                                onClick={this.handleSelfDeactivate}
                                                            >
                                                                Deactivate
                                                            </button>
                                                        </div>
                                                    </section>
                                                </CommonCardShell>
                                            )}
                                </React.Fragment>
                            )}
                        </LeftRailLayout.MainContent>
                    </LeftRailLayout>
                </Layout>
            </div>
        );
    }
}
